import React, { useEffect, useState } from "react";
import axios from "axios";

import "./Home.css";
import { Frame } from "../../components/Frame/Frame";
import { GameFilter } from "../../components/GameFilter/GameFilter";
import { AboutUs } from "../../components/AboutUs/AboutUs";
import Seo from "../../components/Seo/Seo";
import SubscriptionInfo from "../../components/SubscriptionInfo/SubscriptionInfo";
import { GAME_FILTER_ENABLED, SUBSCRIPTIONS_ENABLED } from "../../utils/features";

const HOME_STRUCTURED_DATA = [
  {
    "@context": "https://schema.org",
    "@type": "SportsOrganization",
    name: "ZealFC",
    url: "https://zealfc.com",
    logo: "https://zealfc.com/logo512.png",
    email: "contact@zealfc.com",
  },
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "ZealFC",
    url: "https://zealfc.com",
  },
];

function Home({ isAuthenticated = false }) {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);

  /* one (and only one) request – hits /games/upcoming */
  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_URL}/games/upcoming`
        );
        setGames(data || []);
      } catch (err) {
        console.error("Error fetching upcoming games:", err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <>
      <Seo
        title="ZealFC | Find and Join Football Games"
        description="Discover upcoming football games, join matches, confirm attendance, and manage your next move with ZealFC."
        structuredData={HOME_STRUCTURED_DATA}
      />
      <div className="home-container">
        {/* HERO */}
        <section className="hero-section">
          <div className="noiseeffect" aria-hidden="true" />
          <div className="hero-text">
            <h1>ZEAL</h1>
            <p>CHOOSE YOUR NEXT MOVE</p>
          </div>
        </section>


        {/* CAROUSEL OF UPCOMING GAMES */}
        <div className="upcoming-games">
          <Frame games={games} loading={loading} />
        </div>

        {SUBSCRIPTIONS_ENABLED && <SubscriptionInfo hideSubscriptionDetails />}

        {/* FILTERS: hidden for now, see GAME_FILTER_ENABLED in utils/features. */}
        {GAME_FILTER_ENABLED && <GameFilter games={games} loading={loading} />}

        {/* About Us explains Zeal to people deciding whether to sign up. Someone
            signed in has already made that call. */}
        {!isAuthenticated && <AboutUs />}
      </div>
    </>
  );
}

export default Home;
